module.exports = __webpack_public_path__ + "img/jinja-.68164e59.jpg";